import {Button} from 'antd'
import {exam_getExaminations_Api} from 'apis'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useMemo} from 'react'
import {useLocation} from 'react-use'
import {branch, compose, nest} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import EntityList from 'views/AppLocals/EntityList'
import ExamContext, {ExamProvider} from 'views/AppLocals/Exam/ExamContext'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper from 'views/AppLocals/hooks/usePaginationHelper'
import ListHeader from 'views/AppLocals/Templates/items/ListHeader'
import {NullAsDefault} from 'views/Shared'
import CRUD from 'views/Shared/enums/CRUD'
import {renderExamination} from './renderExamination'
import {LayoutContext} from "../../../components/layouts/Default/LayoutContext";

export const ExaminationsByOwner = ({
  owner_id,
  owner_type,
  renderItem = NullAsDefault,
  ...props
}) => (
  <EntityList
    {...props}
    renderItem={renderItem}
    apiInfo={exam_getExaminations_Api}
    query={bindQueryParams([{ id: owner_id }, { type: owner_type }])}
  />
)

const Examinations = ({ owner_id, owner_type, Wrapper = 'div' }) => {
  const t = useTranslate()

  const {isSm} = useContext(LayoutContext)

  const location = useLocation()

  const {
    refreshKey,
    handleAction = NullAsDefault,
    renderContextMenu = NullAsDefault,
  } = useContext(ExamContext)

  const refresh_deps = useMemo(
    () => [
      owner_id,
      owner_type,
      refreshKey,
      `refreshToken=${_.get(location.state, 'refreshToken')}`,
    ],
    [owner_id, owner_type, refreshKey, location.state]
  )

  const [pager_widget] = usePaginationHelper({
    pagerInfo: {
      RenderEntity: React.Fragment,
      renderItem: renderExamination({
        renderContextMenu,
      }),
      apiInfo: exam_getExaminations_Api,
      query: bindQueryParams([{ id: owner_id }, { type: owner_type }]),
    },
    renderFilter: NullAsDefault,
    SortByWidget: NullAsDefault,
    renderSortBy: NullAsDefault,
    renderSearchBar: NullAsDefault,
    dependencies: [owner_id, owner_type],
    withKey: ({ sortBy, keyword, filterBy }) =>
      [...refresh_deps, sortBy, keyword, JSON.stringify(filterBy)].join('/'),
  })
  return (
    <Wrapper className="flex flex-1 flex-col space-y-3">
      <ListHeader
        title={!isSm && 'examination'}
        extra={
          <Button
            type="primary"
            className="button-rounded-lg no-border"
            onClick={() => {
              handleAction(CRUD.CREATE)
            }}>
            {t('create')}
          </Button>
        }
      />
      {pager_widget}
    </Wrapper>
  )
}

export default compose(
  branch(
    ({ owner_id, owner_type }) => _.some([owner_id, owner_type], _.isEmpty),
    () => () => <ContentNotFound />
  )
)(nest(ExamProvider, Examinations))
